import { Link } from "react-router-dom";
import { useState } from "react";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    school: '',
    role: '',
    interest: 'teacher',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Note: This is a placeholder. In production, this would send to a backend endpoint
    // For now, we'll just show a success message and provide mailto fallback
    const mailtoLink = `mailto:info@examlock.ai?subject=Contact from ${formData.name}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nSchool: ${formData.school}\nRole: ${formData.role}\nInterest: ${formData.interest}\n\nMessage:\n${formData.message}`
    )}`;
    window.location.href = mailtoLink;
    setIsSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-white">

      {/* Hero */}
      <div className="bg-gradient-to-br from-blue-600 to-sky-700 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold mb-6">
            Contact ExamLock
          </h1>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto">
            Interested in trying ExamLock with your class, department, or school? Send a message and we'll get back to you.
          </p>
        </div>
      </div>

      {/* Contact Form & Details */}
      <div className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12">

            {/* Contact Form */}
            <div>
              <h2 className="text-2xl font-bold mb-6 text-gray-900">Send us a message</h2>

              {isSubmitted ? (
                <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center">
                  <div className="text-4xl mb-4">✅</div>
                  <h3 className="text-xl font-semibold text-green-800 mb-2">Message Sent!</h3>
                  <p className="text-green-700">
                    We'll get back to you during Doha business hours (Mon-Fri).
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
                  <div className="space-y-5">
                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Your name"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Email *</label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="your.email@school.edu"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">School / Organisation</label>
                      <input
                        type="text"
                        name="school"
                        value={formData.school}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="School name"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Role</label>
                      <input
                        type="text"
                        name="role"
                        value={formData.role}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="e.g. Teacher, Department Head, IT Director"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">I am interested in *</label>
                      <select
                        name="interest"
                        value={formData.interest}
                        onChange={handleChange}
                        required
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                      >
                        <option value="teacher">Trying ExamLock as a teacher</option>
                        <option value="pilot">Running a school pilot</option>
                        <option value="pricing">School pricing</option>
                        <option value="privacy">Data/privacy questions</option>
                        <option value="support">Support</option>
                      </select>
                    </div>

                    <div>
                      <label className="block text-sm font-semibold text-gray-700 mb-2">Message *</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        rows="5"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        placeholder="Tell us about your needs..."
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      className="w-full py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold text-lg transition-all shadow-lg"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              )}
            </div>

            {/* Contact Details */}
            <div>
              <h2 className="text-2xl font-bold mb-6 text-gray-900">Contact Details</h2>

              <div className="bg-white rounded-xl shadow-lg p-8 mb-8 border border-gray-200">
                <div className="space-y-6">
                  <div>
                    <div className="text-3xl mb-2">📧</div>
                    <h3 className="font-semibold text-gray-900 mb-1">Email</h3>
                    <a href="mailto:info@examlock.ai" className="text-blue-600 hover:text-blue-700">
                      info@examlock.ai
                    </a>
                  </div>

                  <div>
                    <div className="text-3xl mb-2">🌍</div>
                    <h3 className="font-semibold text-gray-900 mb-1">Location</h3>
                    <p className="text-gray-600">Qatar / GCC first</p>
                  </div>

                  <div>
                    <div className="text-3xl mb-2">⏰</div>
                    <h3 className="font-semibold text-gray-900 mb-1">Response Time</h3>
                    <p className="text-gray-600">Mon–Fri, Doha time</p>
                    <p className="text-sm text-gray-500 mt-1">Typically within 24 hours</p>
                  </div>
                </div>
              </div>

              {/* Pilot CTA */}
              <div className="bg-green-50 border-2 border-green-200 rounded-xl p-8">
                <h3 className="text-xl font-bold mb-3 text-gray-900">Want to run a school pilot?</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  ExamLock can support a small pilot with one teacher, one department, or one year group before wider rollout.
                </p>
                <div className="space-y-3">
                  <Link
                    to="/contact"
                    onClick={() => {
                      setFormData({ ...formData, interest: 'pilot' });
                      window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}
                    className="block w-full py-3 bg-green-600 hover:bg-green-700 text-white text-center rounded-lg font-semibold transition-all"
                  >
                    Request Pilot
                  </Link>
                  <Link
                    to="/teacher-register"
                    className="block w-full py-3 bg-white hover:bg-gray-50 text-green-600 text-center rounded-lg font-semibold border-2 border-green-600 transition-all"
                  >
                    Start Free as a Teacher
                  </Link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Additional Info */}
      <div className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-6 text-gray-900">
              Why choose ExamLock?
            </h2>
            <div className="grid sm:grid-cols-3 gap-8">
              <div>
                <div className="text-4xl mb-3">👨‍🏫</div>
                <h3 className="font-semibold text-gray-900 mb-2">Teacher-built</h3>
                <p className="text-sm text-gray-600">Built by a teacher in Qatar for real classroom needs</p>
              </div>
              <div>
                <div className="text-4xl mb-3">🌐</div>
                <h3 className="font-semibold text-gray-900 mb-2">Browser-based</h3>
                <p className="text-sm text-gray-600">No app installation required for students</p>
              </div>
              <div>
                <div className="text-4xl mb-3">🇶🇦</div>
                <h3 className="font-semibold text-gray-900 mb-2">Qatar & GCC focus</h3>
                <p className="text-sm text-gray-600">Designed for IB, IGCSE, NGSS, British curriculum</p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
